/**
 * Interstitial between PHQ-9 and GAD-7 (Figma section transition).
 * @agentic members
 */

import { Paper, Stack, Title, Text, Button, ThemeIcon } from "@mantine/core";

type SectionMilestoneScreenProps = {
  onContinue: () => void;
};

/**
 * Milestone after depression section before anxiety items.
 * @agentic members
 */
export const SectionMilestoneScreen = ({
  onContinue,
}: SectionMilestoneScreenProps) => (
  <Paper radius="lg" p="xl" shadow="sm">
    <Stack align="center" gap="lg">
      <ThemeIcon size={48} radius="xl" color="plum" variant="light">
        ✓
      </ThemeIcon>
      <Title order={3} ta="center" c="#391640">
        Depression section done
      </Title>
      <Text ta="center" size="sm" style={{ opacity: 0.55, color: "#2a1a2e" }}>
        Next up: 7 questions about anxiety. Same format — should take about a
        minute.
      </Text>
      <Button size="md" onClick={onContinue}>
        Continue
      </Button>
    </Stack>
  </Paper>
);
